import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature22',
      playScale: 0.01,
      always: false,
    },
    img: {
      className: 'feature22-img',
      children: 'https://imm.86links.com/assets/landing/feature/Waterfall.jpeg',
    },

  },
};
